import { jsx } from "react/jsx-runtime";
import { Skeleton } from "../../Feedback/Skeleton/index.js";
import { SkeletonVariant } from "../../Feedback/Skeleton/enums.js";
const SelectSkeleton = ({ uniqueId }) => {
  return /* @__PURE__ */ jsx(Skeleton, { uniqueId, variant: SkeletonVariant.Select });
};
export {
  SelectSkeleton
};
